/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Conversion_Error_Web_Page_UnreachableInputs */

const en_conversion_error_web_page_unreachable = /** @type {(inputs: Conversion_Error_Web_Page_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We could not reach this web page. Check the link and try again.`)
};

const es_conversion_error_web_page_unreachable = /** @type {(inputs: Conversion_Error_Web_Page_UnreachableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No pudimos acceder a esta página web. Revisa el enlace e inténtalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "We could not reach this web page. Check the link and try again." |
*
* @param {Conversion_Error_Web_Page_UnreachableInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const conversion_error_web_page_unreachable = /** @type {((inputs?: Conversion_Error_Web_Page_UnreachableInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Conversion_Error_Web_Page_UnreachableInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_conversion_error_web_page_unreachable(inputs)
	return en_conversion_error_web_page_unreachable(inputs)
});